var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Shopping"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/shopping_cart_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833374 1.66666V3.33332H2.50004L5.50004 9.65832L4.37504 11.6917C3.76671 12.8083 4.56671 14.1667 5.83337 14.1667H15.8334V12.5H5.83337L6.75004 10.8333H12.9584C13.5834 10.8333 14.1334 10.4917 14.4167 9.97499L17.4 4.56666C17.7084 4.01666 17.3084 3.33332 16.675 3.33332H4.34171L3.55837 1.66666H0.833374ZM5.83337 15C4.91671 15 4.17504 15.75 4.17504 16.6667C4.17504 17.5833 4.91671 18.3333 5.83337 18.3333C6.75004 18.3333 7.50004 17.5833 7.50004 16.6667C7.50004 15.75 6.75004 15 5.83337 15ZM12.5084 16.6667C12.5084 15.75 13.25 15 14.1667 15C15.0834 15 15.8334 15.75 15.8334 16.6667C15.8334 17.5833 15.0834 18.3333 14.1667 18.3333C13.25 18.3333 12.5084 17.5833 12.5084 16.6667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingwhite);
export default __webpack_public_path__ + "static/media/Shoppingwhite.3f17f121dc55d2227915b8dc14e0381d.svg";
export { ForwardRef as ReactComponent };